import React from 'react';
import { ThemeName } from '@sravni/design-system-theme';
import { ControlledThemeProvider } from './Controlled.js';
import { UncontrolledThemeProvider } from './Uncontrolled.js';
export { ThemeContext } from './Context.js';

/**
 * @description Theme context provider component.
 *
 * @component
 * @example
 * ```jsx
 * <ThemeProvider initialTheme="lager">content</ThemeProvider>
 * ```
 */
function ThemeProvider(props) {
    const { initialTheme, children } = props;
    const isControlled = typeof initialTheme === 'undefined';
    if (isControlled) {
        const { theme, onChange } = props;
        return (React.createElement(ControlledThemeProvider, { theme: theme, onChange: onChange }, children));
    }
    return (React.createElement(UncontrolledThemeProvider, { initialTheme: initialTheme || ThemeName.lager }, children));
}

export { ThemeProvider };
//# sourceMappingURL=index.js.map
